<template>
<div class="c-step-count">
  {{ currentStepNumber }}/{{ stepsCount }} <span class="c-step-count-back" v-on:click="back()" v-if="currentStepNumber > 1">Cofnij</span>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import {
  mapMutations
} from 'vuex'

export default {
  name: 'stepsCounter',
  computed: {
    currentStepNumber: {
      get() {
        return this.$store.state.currentStepNumber
      },
      set(state, payload) {
        this.$store.commit('setCurrentStepNumber', payload)
      }
    },
    stepsCount: {
      get() {
        return this.$store.state.stepsCount
      },
      set(state, payload) {
        this.$store.commit('setStepsCount', payload)
      }
    },
  },
  methods:{
    back(){
      // console.log(this.currentStepNumber);

      this.$store.commit('setCurrentStepNumber', Number(this.currentStepNumber)-1);
      this.$store.commit('setCurrentStepComponent', 'step'+this.currentStepNumber);

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .c-step-count-back{
    color: #070A4F;
    font-size: .8rem;
  }
</style>
